export default [
    {
        type: 'doc',
        suffixs: ['txt', 'pdf', 'doc', 'docx', 'dot', 'dotx'],
        label: '文稿',
    },
    {
        type: 'xls',
        suffixs: ['xls', 'xlsx', 'csv', 'vsd'],
        label: '电子表格',
    },
    {
        type: 'ppt',
        suffixs: ['ppt', 'pptx'],
        label: '演示文稿',
    },
    {
        type: 'audio',
        suffixs: ['mp3', 'wav'],
        label: '音频',
    },
    {
        type: 'video',
        suffixs: ['mp4', 'rmvb', 'mkv', 'avi', 'wmv', 'mov', '3gp'],
        label: '短视频',
    },
    {
        type: 'zip',
        suffixs: ['zip', 'rar'],
        label: '压缩包',
    },
    {
        type: 'img',
        suffixs: ['jpg', 'jpeg', 'png', 'gif', 'bmp'],
        label: '图片',
    },
    {
        type: 'others',
        label: '其他',
    },
];
